import React from "react";

import FieldItem from "../FormField";
import { StyledInput } from "./styles";

const TextField = ({
  name,
  label,
  rules,
  tooltip,
  icon,
  ...props
}) => (
  <FieldItem name={name} label={label} rules={rules} tooltip={tooltip}>
    <StyledInput prefix={icon} {...props} />
  </FieldItem>
);

export default TextField;
